import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
	return (
		<SonnerToaster
			position="top-center"
			expand
			richColors
			duration={4000}
			toastOptions={{
				style: {
					fontFamily: "var(--font-sans)",
					borderRadius: "var(--radius-md)",
					padding: "0.85rem 1rem",
					border: "1px solid var(--color-border)",
					background: "var(--color-surface)",
					color: "var(--color-text)",
					boxShadow: "var(--shadow-md)",
				},
			}}
		/>
	);
}
